export class Formulaire {
  #index = 0
  #tabs = null

  // configuration: tableau de route.
  // chaque routes doit comporter un `string path`, un `string name`
  // et peut avoir une `Func<object, bool> condition` qui va définir si la route est accessible dans le formulaire.
  constructor (routeName, configuration) {
    this.routeName = routeName
    this.configuration = configuration
  }

  getTabs () {
    if (this.#tabs === null) {
      this.#tabs = this.configuration.map(config => this.#buildConfiguration(config))
    }

    return this.#tabs
  }

  #buildConfiguration (config) {
    return {
      index: this.#index++,
      //route: '', // todo: activite-reservee
      path: config.path,
      componentPath: this.routeName + '/' + config.path,
      name: config.name,
      condition: config.condition || (() => true)
    }
  }
}
